const ApproachSection = () => {
  return (
    <section className="relative bg-white py-10 sm:py-12 md:py-20 lg:py-16 overflow-hidden">
      <div
        className="absolute top-1/2 right-0 transform -translate-y-1/2 h-full w-1/2 hidden lg:block"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, transparent, transparent 20px, hsla(195, 53%, 90%, 0.2) 20px, hsla(195, 53%, 90%, 0.2) 22px)",
        }}
      />
      <div className="container mx-auto px-5 sm:px-6 lg:px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 xl:gap-16 items-center">
          <div className="group order-2 lg:order-1">
            <img
              src="/assest/architects-making-thumbs-up-gesture.jpg"
              alt="A professional business team having a discussion in a modern office"
              className="rounded-lg sm:rounded-xl shadow-lg w-full h-auto object-cover object-center transition-all duration-300 ease-in-out group-hover:shadow-2xl group-hover:scale-[1.03]"
            />
          </div>

          <div className="order-1 lg:order-2">
            <span className="section-label text-xs sm:text-sm">Our Approach to</span>
            <h2 className="text-3xl sm:text-[36px] lg:text-[40px] font-bold text-brand-navy font-display mt-2 mb-5 sm:mb-6 leading-tight">
              Getting Things Done
            </h2>
            <blockquote className="my-6 sm:my-8">
              <p className="quote-text text-base sm:text-lg md:text-xl">
                "Every person is born with a talent, and happiness depends on
                discovering that talent in time. "
              </p>
              <footer className="quote-attribution text-right mt-2 pr-4 text-sm">
                - Isabel Allende
              </footer>
            </blockquote>
            <div className="space-y-3 sm:space-y-4 text-dark-gray text-sm sm:text-base font-body leading-[1.7]">
              <p>
                Unlike other manpower companies in India, IMMACULATE takes
                pleasure in finding the right talent. For us, it's not about
                supplying manpower; it's about providing talent. To this end, we
                partner with clients to deliver the right people for the
                desired services.
              </p>
              <p>
                What sets us apart is our unwavering commitment to enhancing
                your business. While others merely focus on supplying manpower,
                we emphasize on supplying excellence.
              </p>
              <p>
                IMMACULATE enhances the quality, productivity, and
                efficiency of our workforce through assessment, training and
                development, workforce consulting, outsourcing, and career
                management.
              </p>
              <p>
                Ultimately, at IMMACULATE, we believe that our happiness in this
                world is proportional to the extent to which we make others
                happy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;